<template>
  <div class="section-main__warp history-alarm">
    <div class="ioc-history__list">
      <ioc-table ref="refTable" :option="tableOption" :data="tableData" :page="page" @search-change="handleSearch"
        @search-reset="handleReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        <template slot="search_deviceName">
          <el-input v-model="deviceName" @focus="getDeviceList" readonly placeholder="请选择摄像机"></el-input>
          <span class="el-icon-circle-close" @click="handleClear" v-if="deviceName"
            style="cursor: pointer; position: absolute; top: 10px; right: 10px">
          </span>
          <span class="el-icon-arrow-down" @click="getDeviceList" v-if="!deviceName"
            style="cursor: pointer; position: absolute; top: 10px; right: 10px">
          </span>
        </template>
        <template slot="search_alarmLevel">
          <el-select placeholder="请选择" v-model="alarmLevel" multiple>
            <el-option v-for="item in alarmLevels" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
        <!-- <template slot="search_subSystem">
          <el-select placeholder="请选择" v-model="subSystem" multiple>
          <el-option
            v-for="item in subSystems"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        </template> -->
        <template slot="search_alarmTypelabel">
          <el-cascader :title="typeLabel" v-model="alarmType" ref="cascaderPanel" placeholder="默认全部类型"
            :show-all-levels="false" :options="cascaderOptions" :props="cascaderProps" collapse-tags></el-cascader>
        </template>
        <template slot="menuLeft" slot-scope="scope">
          <el-button type="primary" icon="el-icon-download" v-auth="'/historyAlarm:export'" @click="exportFile(scope)"
            :loading="disabled">
            {{ disabled ? "导出中" : $t("historyAlarm.button.export") }}
          </el-button>
        </template>

        <template slot="menu" slot-scope="scope">
          <!-- 详情 -->
          <el-tooltip class="item" effect="dark" :content="$t('historyAlarm.label.details')" placement="top"
            popper-class="tooltip-draw">
            <el-button type="text" @click="handleView(scope.row, scope.index)" icon="iconfont icon-Detail"></el-button>
          </el-tooltip>
          <!-- <el-tooltip class="item m5" v-if="scope.row.alarmType == '80101'" effect="dark" content="轨迹查询"
            placement="top-start">
            <span class="iconfont-lunan icon-blue el-icon-location cursor"
              @click="trackBtn(scope.row)"></span>&nbsp;&nbsp;&nbsp;&nbsp;
          </el-tooltip> -->
        </template>
        <template slot="alarmLevel" slot-scope="scope">
          <span :class="alarmColor(scope.row.alarmLevel)" style="cursor: pointer"
            @click="handleView(scope.row, scope.index)">
            {{ scope.row.alarmLevel | dic("SENU017") }}</span>
        </template>
        <template slot="subSystem" slot-scope="scope">
          <span> {{ scope.row.subSystemlabel }}</span>
        </template>
        <template slot="alarmState" slot-scope="scope">
          <span> {{ scope.row.alarmState | dic("SENU068") }}</span>
        </template>
      </ioc-table>
    </div>
    <appPanel class="app-panel" :isExpand="showPanel" @cancel="closeDialog" :title="$t('historyAlarm.title.alarmDetail')">
      <el-scrollbar style="height: 100%">
        <div class="ioc-detail">
          <div class="ioc-group" v-if="currentAlarm.subSystem != '12' &&
            (currentAlarm.alarmSnapUrl || currentAlarm.picUrl)
            ">
            <div class="el-row ioc-group__item" span="24">
              <div class="ioc-group__header">
                <!---->
                <h3 class="ioc-group__title">
                  {{ $t("historyAlarm.title.SnapshotPreview") }}
                </h3>
              </div>
              <div class="ioc-detail__image" style="margin: 10px 0">
                <template v-if="currentAlarm.alarmSnapUrl || currentAlarm.picUrl">
                  <div v-if="currentAlarm.alarmType == '50102' && currentAlarm.subSystem !== '9'
                    " key="alarmPicture" class="flex-between black-list-pic-area">
                    <div class="black-list-pic">
                      <span class="pic-title">抓拍人员</span>
                      <img class="lookPhoto" v-if="currentAlarm.alarmSnapUrl || currentAlarm.picUrl"
                        :src="imgPath(currentAlarm.alarmSnapUrl || currentAlarm.picUrl)" alt @click="showViewer"
                        onerror="this.src='/images/theme/newDark/imgError.png'" />
                    </div>
                    <div class="black-list-pic">
                      <span class="pic-title">黑名单人员</span>
                      <img class="lookPhoto" v-if="currentAlarm.picFileId" :src="imgPath(currentAlarm.picFileId)" alt
                        @click="showViewer" onerror="this.src='/images/theme/newDark/imgError.png'" />
                    </div>
                    <span class="similarity-text">{{ currentAlarm.similarity }}%</span>
                  </div>

                  <el-carousel :interval="4000" type="card" height="200px" v-else-if="currentAlarm.subSystem === '9'">
                    <el-carousel-item v-for="item in (currentAlarm.picUrl || '').split(',')" :key="item">
                      <img class="lookPhoto" :src="imgPath(item)" style="width: 300px; height: 180px" alt
                        @click="showViewer" onerror="this.src='/images/theme/newDark/default.png'" />
                    </el-carousel-item>
                  </el-carousel>

                  <el-carousel :interval="4000" type="card" height="200px" v-else>
                    <el-carousel-item v-for="item in (currentAlarm.alarmSnapUrl || currentAlarm.picUrl).split(',')"
                      :key="item">
                      <img class="lookPhoto" :src="imgPath(item)" style="width: 300px; height: 180px" @click="showViewer"
                        onerror="this.src='/images/theme/newDark/imgError.png'" />
                    </el-carousel-item>
                  </el-carousel>
                </template>

                <!-- <template v-else>
                  <img style="height: 120px; width: 100%" :src="`/images/theme/newDark/no-img.jpg`" />
                </template> -->
              </div>
            </div>
          </div>
          <!-- 告警详情 -->
          <div class="ioc-group">
            <div class="el-row ioc-group__item" span="24">
              <div class="ioc-group__header">
                <h3 class="ioc-group__title">
                  {{ currentAlarm.subSystem !== "12" ? "" : "一键求救*"
                  }}{{ $t("historyAlarm.title.alarmDetail") }}
                </h3>
              </div>

              <div class="el-col el-col-24 el-col-xs-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">
                    告警名称 ：
                  </span>
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmName
                  }}</span>
                </div>
              </div>

              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{ $t("historyAlarm.title.alarmType") }} ：
                  </span>
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmTypeLabel
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.alarmType == '80101'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">限速 ：</span>
                  <span class="ioc-detail__content pl5">{{ currentAlarm.overSpeed }}km/h</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.alarmType == '80101'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">当前车速 ：</span>
                  <span class="ioc-detail__content pl5">{{ currentAlarm.speed }}km/h</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.alarmType == '80101'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">上浮速度 ：</span>
                  <span class="ioc-detail__content pl5">{{ currentAlarm.floatSpeed }}km/h</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.alarmType == '80101'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">车牌 ：</span>
                  <span class="ioc-detail__content pl5">{{ currentAlarm.plateNo }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{ $t("historyAlarm.title.alarmLevel") }}
                    ：</span>
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmLevel | dic("SENU017")
                  }}</span>
                </div>
              </div>
              <!---->
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{ $t("historyAlarm.title.alarmTime") }}
                    ：</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmTime | moment
                  }}</span>
                </div>
              </div>
              <!---->
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem != '14'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">设备组名称 ：</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.deviceWorkGroupName
                  }}</span>
                </div>
              </div>
              <!---->
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem == '14'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">监控点名称 ：</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.deviceName
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem == '14'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">探测器名称 ：</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.parentDeviceName
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem == '14'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">浓度值 ：</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.concentration
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">所属中队 ：</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.securityWorkGroupNames
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12"
                v-if="currentAlarm.subSystem != '12' && currentAlarm.subSystem != '14'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">
                    录像回放 ：
                  </span>
                  <span class="ioc-detail__content pl5">
                    <span v-if="!currentAlarm.playBackUrl">{{
                      $t("historyAlarm.label.no")
                    }}</span>
                    <span v-else>
                      <img @click="viewVideo" style="cursor: pointer" src="@src/common/assets/images/video.png" alt="" />
                    </span>
                  </span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24" v-if="uploadVideoShow &&
                (currentAlarm.subSystem == '9' ||
                  currentAlarm.subSystem == '10' ||
                  currentAlarm.subSystem == '11')
                ">
                <div class="ioc-detail__box mt10" style="display: flex">
                  <span class="ioc-detail__label ioc-detail__label--right">上传视频 ：</span>
                  <span class="ioc-detail__content pl5">
                    <span v-if="!currentAlarm.videoUrl">{{
                      $t("historyAlarm.label.no")
                    }}</span>
                    <span v-else style="display: flex">
                      <div class="file-item" v-for="(item, index) in currentAlarm.videoUrl.split(',')" :key="index">
                        <video style="object-fit: fill" class="file-comp" :src="$utils.Bus.imgPath(item)"></video>
                        <div style="cursor: pointer" class="play-icon iconfont-lunan icon-lunan-qidong"
                          @click="handleShowVideos(item)"></div>
                      </div>
                    </span>
                  </span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-show="currentAlarm.reportPersonName">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">上报人 ：</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.reportPersonName
                  }}</span>
                </div>
              </div>
              <!-- 一键求救 -->
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem == '12'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">故障类型 ：</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmSubType | dic("SENU103")
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem == '12'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">一键求救设备 ：</span>
                  <!---->
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.deviceName
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem == '12'">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">设备位置 ：</span>
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.groupName
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.label.warnDesc")
                  }}</span>
                  <span class="ioc-detail__content handle-desc pl5">{{
                    currentAlarm.desc
                  }}</span>
                </div>
              </div>
              <!---->
            </div>
          </div>
          <div class="ioc-group">
            <div class="el-row ioc-group__item" span="24">
              <div class="ioc-group__header">
                <h3 class="ioc-group__title">
                  {{ $t("historyAlarm.title.dealWith") }}
                </h3>
              </div>
              <div class="el-col el-col-24 el-col-xs-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.title.Processingpers")
                  }}</span>
                  <span class="ioc-detail__content pl5">{{
                    currentAlarm.modifierName || currentAlarm.modifier
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.title.ProcessingDes")
                  }}</span>
                  <!---->
                  <span class="ioc-detail__content pl5 handle-desc">{{
                    currentAlarm.processDesc
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box mt10">
                  <span class="ioc-detail__label ioc-detail__label--right">
                    处理时间 ：{{ currentAlarm.modifyTime | moment }}
                  </span>
                  <!---->
                  <!-- <span class="ioc-detail__content pl5 handle-desc">{{
                  currentAlarm.processDesc
                }}</span> -->
                </div>
              </div>
              <!---->
            </div>
          </div>
        </div>
      </el-scrollbar>

      <div slot="footer">
        <el-button type="info" @click="closeDialog"> 关闭 </el-button>
        <el-button type="primary" v-show="currentAlarm && currentAlarm.taskCode" @click="handelShowTaskDetail">
          {{ $t("historyAlarm.title.viewTask") }}
        </el-button>
      </div>
    </appPanel>
    <!-- 任务详情 -->
    <appPanel class="app-panel taskDetail-container" :isExpand="showPanelTask" @cancel="showPanelTask = false"
      :title="$t('historyAlarm.title.taskDetail')">
      <el-scrollbar style="height: 100%">
        <ioc-detail :option="taskOption" v-model="currentTask"></ioc-detail>

        <div class="ioc-detail__box clearfix img-content mt10" style="margin: 0px 0px 0px 10px">
          <span class="ioc-detail__label ioc-detail__label--right">{{
            $t("historyAlarm.label.relatedDocuments")
          }}</span>
          <span class="ioc-detail__content fl">
            <app-file-list-show :fileInfoList="currentTask.fileInfoList" :taskAlarmInfo="currentAlarm"
              @enlargeImage="enlargeImage"></app-file-list-show>
          </span>
        </div>
        <ioc-tab-group style="margin: 10px 0px 0px 10px" :option="tapOption" @change="handleTabChange"></ioc-tab-group>
        <div v-if="currentTab.prop === 'tab1' || !currentTab.prop" style="height: 160px; margin: 0px 0px 0px 10px">
          <el-table ref="personList" :data="currentTask.subTaskInfoList" style="width: 100%">
            <el-table-column prop="executor" :label="$t('historyAlarm.label.exeNumber')">
            </el-table-column>
            <el-table-column prop="executorName" :label="$t('historyAlarm.label.executive')">
            </el-table-column>
            <el-table-column prop="status" :label="$t('historyAlarm.label.implementation')">
              <template slot-scope="scope">
                {{ scope.row.status | dic("SENU055") }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else-if="currentTab.prop === 'tab2'" style="padding: 0 20px; margin: 0px 0px 0px 10px">
          <div>
            <el-timeline class="timeLine">
              <el-timeline-item v-for="(activity, index) in currentTask.taskExecutionLogList" :key="index" placement="top"
                :timestamp="activity.operateTime | moment">
                <p class="action">
                  {{ $t("taskCenter.label.action") }}
                  {{ formatter(execute, activity.action) }}
                </p>
                <p>执行人 ：{{ activity.operator }}</p>

                <p>催办执行人 ：{{ activity.executor }}</p>
                <p class="word-break-all" style="margin: 12px 0">
                  描述 ：{{ activity.desc }}
                </p>
                <el-row>
                  <el-col :span="6"> 相关文件 ： </el-col>
                  <el-col :span="16">
                    <app-file-list-show :fileInfoList="activity.fileInfos"
                      @enlargeImage="enlargeImage"></app-file-list-show>
                  </el-col>
                </el-row>
              </el-timeline-item>
            </el-timeline>
            <!-- 执行明细无数据时展示暂无数据 -->
            <div v-if="currentTask.taskExecutionLogList.length === 0" class="table-empty" style="text-align: center">
              <img src="@/common/assets/images/empty.svg" />
              <p>{{ $t("base.label.empty") }}</p>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div class="footer-content" slot="footer">
        <el-button type="primary" @click="showPanelTask = false" class="confirm">
          {{ $t("historyAlarm.button.close") }}
        </el-button>
      </div>
    </appPanel>
    <el-dialog :title="$t('historyAlarm.title.resourcesDetail')" :visible.sync="resourceDailogShow" width="700px"
      append-to-body v-dialogDrag :before-close="resourceClose">
      <resource-show ref="resourceDialog" :resourceUrl="currentResource" :taskAlarmInfo="currentAlarm"></resource-show>
    </el-dialog>
    <alarmVideos ref="alarmVideos" :videoList="currentAlarm.manuaAlarmPicList" @enlargeResource="enlargeResource">
    </alarmVideos>
    <fastLinkDeviceList ref="fastLinkDeviceList" :deviceList="videoDeviceArr" @playVideo="playVideo">
    </fastLinkDeviceList>
    <!--展示资源大图-->
    <el-dialog :title="$t('historyAlarm.title.resourcesDetail')" :visible.sync="resourceAlarmDailogShow" width="540px"
      v-dialogDrag append-to-body :close-on-click-modal="false" :before-close="resourceClose">
      <!-- 该行数据currentResource，告警详情taskAlarmInfo都必须有 -->
      <resource-show-alarm ref="resourceAlarmDialog" :resourceUrl="currentResource"
        :alarmInfo="currentAlarm"></resource-show-alarm>
    </el-dialog>
    <el-dialog title="摄像机组列表" :visible.sync="showTreeList" v-dialogDrag width="350px">
      <div style="height: 350px; position: relative">
        <camera-tree ref="cameraTree" @currentChange="currentChange"> </camera-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" @click="submitDialog">确 定</el-button>
      </span>
    </el-dialog>
    <div>
      <el-dialog :before-close="handleCloseVideo" :visible.sync="dialogShowVideo" append-to-body title="上传视频"
        width="600px">
        <div style="width: 100%; height: 380px">
          <video autoplay muted style="width: 100%; height: 100%; object-fit: fill" controls="controls"
            :src="$utils.Bus.downFile(dialogShowVideoSrc)"></video>
        </div>
      </el-dialog>
    </div>
    <deviceTree ref="deviceTree" :showCheckbox="false" :ajaxOption="ajaxOption" :deviceOption="deviceOption"
      @saveChecked="handleSaveChecked"></deviceTree>
    <dialog-map ref="dialogMap"></dialog-map>
  </div>
</template>
<script>
import appPanel from "@src/components/business/app-panel/index.vue";
import { alarmFilterOption } from "../const/HistoryAlarmFilter";
import { alarmTableOption } from "../const/HistoryAlarmTable";
import { moreFilterOption } from "../const/HistoryMoreFilter.js";
import { alarmOptions } from "../const/alarmOptions.js";
import {
  taskOption,
  taskOptionFinish,
  tapOption,
  taskAlarmOption,
} from "../const/taskOptions.js";
import { Dates, Bus, Dic, Base, Cache } from "$utils";
import { api } from "../api";
import utils from "@src/common/utils";
import resourceShow from "@src/components/business/app-resource-show";
import resourceShowAlarm from "@src/components/business/app-resource-show-alarm";
import appFileListShow from "@src/components/business/app-file-list-show";
import alarmVideos from "@src/components/business/app-resource-show-alarm/alarmVideos.vue";
import deviceTree from "@src/components/business/app-device-tree";
import fastLinkDeviceList from "@src/components/business/app-alarm/fastLinkDeviceList.vue";
import dialogMap from "@src/components/common/app-dialog/dialog-map";
import cameraTree from "@src/modules/identifyCenter/components/cameraTree.vue";
export default {
  components: {
    cameraTree,
    resourceShow,
    appFileListShow,
    alarmVideos,
    fastLinkDeviceList,
    resourceShowAlarm,
    dialogMap,
    appPanel,
    deviceTree,
  },
  data() {
    return {
      cascaderProps: {
        multiple: true,
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: false,
        expandTrigger: "hover",
      },
      cascaderOptions: [],
      alarmLevel: [],
      alarmType: [],
      // subSystem: [],
      deviceName: "",
      deviceOption: {
        icon: "iconfont-lunan icon-lunan-shexiangtou",
        nodeType: "device",
        key: "id",
      },
      ajaxOption: {
        api: "/bms/device/queryDeviceWorkGroupDeviceTree.json",
        params: {
          deviceType: 10,
        },
      },
      dialogShowVideoSrc: "",
      dialogShowVideo: false,
      showPanelTask: false,
      showPanel: false,
      showTreeList: false,
      isDevice: true,
      ocx: {
        x: 1000,
        y: 400,
      },
      execute: Dic.find("SENU056"), // 执行动作
      moreFilterText: this.$t("historyAlarm.label.screening"),
      uploadVideoShow: true,
      resourceDailogShow: false,
      resourceAlarmDailogShow: false,
      currentResource: [],
      devicesList: [],
      types: {
        image: "image",
        video: "video",
      },
      Base,
      Bus,
      isShowMore: false,
      queryForm: {
        startTime: new Date(Date.now() - 89 * 24 * 3600 * 1000),
        endTime: new Date(),
        // date: [new Date(Date.now() - 89 * 24 * 3600 * 1000), new Date()],
      },
      moreQueryForm: {},
      tableData: [],
      tablePersonListData: [],
      page: {
        // 当前页
        currentPage: 1,
        // 查询记过总计
        total: 0,
        // 每页默认显示条数
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      areaTree: {},
      currentAlarm: {
        videoUrl: "",
      },
      currentTask: {},
      currentTab: {},
      subOptions: [],
      // subSystems: Dic.find("SENU004"),
      alarmLevels: Dic.find("SENU017"),
      // alarmTypes: Dic.find('SENU004005'),
      alarmTypes: [],
      tableOption: alarmTableOption(this),
      filterOption: alarmFilterOption(this),
      morefilterOption: moreFilterOption(this),
      detailOption: alarmOptions(this),
      taskOption: taskOption(this),
      tapOption: tapOption(this),
      taskAlarmOption: taskAlarmOption(this),
      formData: {
        // 查询条件表单数据
        areas: [], // 区域
        areasName: "",
      },
      cacheParams: null,
      videoDeviceArr: [],
      // 导出按钮是否禁用
      disabled: false,
      deviceArr: [],
      deviceData: [],
      personData: [],
      carData: [],
      identifyData: [],
      fireData: [],
      options: [
        { label: "人员", value: "1", children: [] },
        { label: "车辆", value: "2", children: [] },
        { label: "周界入侵", value: "3", children: [] },
        { label: "消防通道占用", value: "4", children: [] },
      ],
      showAll: false,
      alarmSubSys: []
    };
  },
  created() {
    this.getAlarmTypeAndSubsystem();
    // this.subSystems.forEach((item, index) => {
    //   if (item != 4 || item != 13) {
    //     this.subSystems.push(item);
    //   }
    // });
    // this.$nextTick(() => {
    //   if (!this.subSystems.length) {
    //     this.subSystems = [5, 8, 9, 10, 11, 12];
    //   }
    //   // this.getList(this.page, this.queryForm);
    // });
    Dic.find("SENU004").forEach((item, index) => {
      if (item.value != 4 && item.value != 13) {
        this.subOptions.push(item);
      }
    });
    this.getDevices();
  },
  computed: {
    typeLabel() {
      if (this.alarmType) {
        return this.$refs.cascaderPanel && this.$refs.cascaderPanel.inputValue;
      } else {
        return "";
      }
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
  },
  mounted() {
    this.handleReset();
  },
  methods: {
    getAlarmTypeAndSubsystem() {
      const self = this;
      // 实时告警页面系统类型去除消防子系统和电器火灾
      this.$fetch(api.bas.getAlarmTypeAndSubsystem, {}).then((response) => {
        let subList = [];
        response.returnObj.forEach((item, index) => {
          if (item.id != "4" && item.id != "13" && item.id != "14") {
            subList.push(item);
          }
        });
        self.cascaderOptions = [...subList];
        this.alarmSubSys = subList.map(item => {
          return item.id
        })
      });
    },
    handleSaveChecked(node) {
      this.deviceName = node[0].name;
      this.$refs.refTable.searchForm["deviceName"] = node[0].name;
    },
    handleClear() {
      this.deviceName = "";
      this.$refs.refTable.searchForm["deviceName"] = "";
    },
    getDeviceList() {
      this.$refs["deviceTree"].openDialog(this.queryForm.alarmArea);
    },
    handleSearch(query) {
      this.queryForm = { ...query };
      this.queryForm.startTime = query.alarmTime && query.alarmTime[0];
      this.queryForm.endTime = query.alarmTime && query.alarmTime[1];
      this.queryForm.deviceName = query.deviceName && query.deviceName;
      this.queryForm.securityWorkGroupName =
        query.securityWorkGroupNames && query.securityWorkGroupNames;
      this.getList(this.page, this.queryForm);
    },
    handleReset() {
      this.queryForm = {
        startTime: new Date(Date.now() - 89 * 24 * 3600 * 1000),
        endTime: new Date(),
      };
      (this.alarmTypes = []),
        (this.alarmLevel = []),
        (this.alarmType = []),
        (this.deviceName = "");
      this.page.pageSize = 10;
      this.page.currentPage = 1;
      let form = this.$refs.refTable.searchForm;
      this.$set(form, "alarmTime", [
        Dates.format(this.queryForm.startTime),
        Dates.format(this.queryForm.endTime),
      ]);
      this.$set(form, "subSystem", ["5","9","10","11","17","99"]);
      this.$refs.refTable.query();
    },
    currentChange(data) {
      this.deviceData = data;
    },
    // 获取告警设备来源
    async getDevices() {
      await this.queryControlTaskCamera("1");
      await this.queryControlTaskCamera("2");
      await this.queryControlTaskCamera("3");
      await this.queryControlTaskCamera("4");
      // this.tableOption.column[9].dicData = this.options;
    },
    queryControlTaskCamera(type) {
      let params = {
        controlFlag: 1,
        controlType: type,
      };
      this.$fetch(api.historyAlarm.queryControlTaskCamera, params).then((res) => {
        if (res.success) {
          let arr = [];
          arr = res.returnObj.map((item) => {
            return {
              label: item.deviceName,
              value: item.deviceName,
            };
          });
          this.options[type - 1].children = arr;
        }
      });
    },
    submitDialog() {
      this.$nextTick(() => {
        if (this.deviceData != null) {
          this.queryForm.deviceName = this.deviceData.name;
          this.showTreeList = false;
        } else {
          this.$message.warning("请选择至少一个设备");
        }
        console.log(this.$refs.cameraTree.$refs.tree.getCheckedKeys(), "===");
        //  this.$refs.cameraTree.getCheckedNodes()
      });
      // this.queryForm.deviceName
      //   ? (this.showTreeList = false)
      //   : this.$message.warning("请选择设备");
    },
    cancelDialog() {
      this.queryForm.deviceName = "";
      this.showTreeList = false;
    },
    chooseDevice(item) {
      this.queryForm.deviceName = item.name;
    },
    selectDevice() {
      this.queryForm.deviceName = "";
      this.showTreeList = true;
    },
    trackBtn(row) {
      this.$refs.dialogMap.openMap(row, 1, {
        startTime: Dates.parse(
          Dates.format(new Date(row.alarmTime).getTime() - 1000 * 5 * 60)
        ),
        endTime: Dates.parse(
          Dates.format(new Date(row.alarmTime).getTime() + 1000 * 5 * 60)
        ),
        plateCode: row.plateCode, //车牌号
      });
    },
    showViewer(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    formatter(dataList, value) {
      let rtn = "";
      dataList.map((item) => {
        if (item.value == value) {
          rtn = item.label;
        }
      });
      return rtn;
    },
    // 导出
    exportFile() {
      if (!this.queryForm.startTime || !this.queryForm.endTime) {
        this.$confirm(
          this.$t("historyAlarm.message.alarmTime"),
          this.$t("historyAlarm.title.prompt"),
          {
            confirmButtonText: this.$t("historyAlarm.button.confirm"),
            cancelButtonText: this.$t("historyAlarm.button.cancel"),
            type: "warning",
          }
        ).then(() => {
          this.queryForm.startTime = Date.now() - 7 * 24 * 3600 * 1000;
          (this.queryForm.endTime = new Date()), this.fetchDownLoadFile();
        });
      } else {
        this.fetchDownLoadFile();
      }
    },
    fetchDownLoadFile() {
      console.log(this.queryForm);
      let params = {
        alarmType: this.alarmTypes,
        alarmLevel: this.alarmLevel,
        alarmTitle: this.queryForm.alarmTitle,
        alarmStartTime: this.queryForm.startTime,
        alarmEndTime: this.queryForm.endTime,
        areas: this.queryForm.alarmArea || [],
        alarmDevices: [],
        securityWorkGroupName: this.queryForm.securityWorkGroupName,
        // subSystem: ["5", "8", "9", "10", "11", "12", "15"],
        subSystem: this.alarmSubSys
      };
      // 兼容IE
      let start_time = Dates.format(
        new Date(this.queryForm.startTime),
        "yyyy/MM/dd 00:00:00"
      );
      let end_time = Dates.format(
        new Date(this.queryForm.endTime),
        "yyyy/MM/dd 23:59:59"
      );
      let startTime = new Date(start_time).getTime();
      let endTime = new Date(end_time).getTime();
      if (endTime - startTime > 90 * 24 * 60 * 60 * 1000) {
        this.$message.warning(this.$t("historyAlarm.message.export90"));
        return;
      }
      this.disabled = true;
      this.$fetchDownLoad(api.bas.exportAlarm, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        const content = response.data;
        const blob = new Blob([content], { type: "application/zip" });
        const fileName =
          this.$t("historyAlarm.title.historyAlarm") +
          Dates.format(Date.now(), "yyyyMMddHHmmssms") +
          ".zip";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
        this.disabled = false;
      });
    },
    // 显示资源大图
    enlargeResource(item) {
      // this.currentResource = [item]
      this.currentResource = item;
      this.resourceAlarmDailogShow = true;
    },
    resourceClose() {
      if (this.$refs.resourceDialog) {
        this.$refs.resourceDialog.stopVideo();
      }
      this.resourceDailogShow = false;
      if (this.$refs.resourceAlarmDialog) {
        this.$refs.resourceAlarmDialog.stopVideo();
      }
      this.resourceAlarmDailogShow = false;
    },
    alarmName(v) {
      if (v) {
        let deviceName = this.currentAlarm.deviceName;
        if (v[0] == "5") {
          return deviceName
            ? Dic.findByValue("SENU004005", v) + "_" + deviceName
            : Dic.findByValue("SENU004005", v);
        } else if (v[0] == "6") {
          return deviceName
            ? Dic.findByValue("SENU004006", v) + "_" + deviceName
            : Dic.findByValue("SENU004006", v);
        }
      } else {
        return this.$t("historyAlarm.label.no");
      }
    },
    saveChecked(data) {
      this.queryForm.alarmArea = data.map((item) => {
        return item.areaDevGroupCode;
      });
      this.formData.areasName = data
        .map((item) => {
          return item.areaDevGroupName;
        })
        .join("/");
    },
    handleShowVideos(src) {
      this.dialogShowVideoSrc = src;
      this.dialogShowVideo = true;
    },
    handleCloseVideo() {
      this.dialogShowVideo = false;
      this.dialogShowVideoSrc = "";
    },
    // 图片enlargeImage(fileCode) {
    enlargeImage(item) {
      this.resourceDailogShow = true;
      // this.currentResource = [item]

      this.currentResource = item;
    },
    alarmImage(item) {
      // const token = Cache.get('access_token')
      const token = this.userInfo.access_token;
      let url = "";
      switch (item.picResourceType) {
        case 1:
          url = `${api.bas.picStreamInfo}?resourceCode=${item.resourceCode}&ticket=${token}`;
          console.log("图片地址", url);
          break;
        case 3:
          url = `${api.bas.picStreamInfo}?alarmId=${item.alarmId}&alarmType=${item.alarmType}&deviceId=${item.deviceId}&picResourceType=${item.picResourceType}&ticket=${token}`;
          break;
        case 4:
          url = `${api.bas.picStreamInfo}?alarmId=${item.alarmId}&alarmType=${item.alarmType}&picResourceType=${item.picResourceType}&ticket=${token}`;
          break;
        default:
          url = `${api.bas.picStreamInfo}?picResourceType=${item.picResourceType}&alarmType=${this.currentAlarm.alarmType}&alarmId=${this.currentAlarm.alarmId}&ticket=${token}&resourceCode=${item.resourceCode}`;
      }
      return url;
    },
    imgPath(item = "") {
      return item ? Bus.imgPath(item) : "";
    },
    getCameraData() { },
    closeCameraWindow() { },
    getCameraList(val) {
      this.devicesList = val.map((item) => {
        return {};
      });
    },
    getList(page, arg = {}) {
      console.log(this.alarmType, '@@##$$')
      // if (this.alarmType) {
      //   this.alarmType.forEach((item, index) => {
      //     item.forEach((itemChild, index) => {
      //       item.splice(0, 1);
      //     });
      //   });
      // }
      if (this.alarmType) {
        this.alarmType.forEach((item, index) => {
          item.forEach((itemChild, index) => {
            this.alarmTypes.push(itemChild);
          });
        });
      }
      console.log('this.alarmTypes', this.alarmTypes)
      const _this = this;
      let dateArr = _this.initDateFormat();
      let params = {
        alarmStartTime: arg.startTime || dateArr[0],
        alarmEndTime: arg.endTime || dateArr[1],
        // subSystem: ["5", "8", "9", "10", "11", "12", "15"],
        subSystem: this.alarmSubSys,
        alarmType: this.alarmTypes,
        alarmLevel: this.alarmLevel,
        ...arg,
        // deviceName: arg.deviceName && arg.deviceName[1],
        // securityWorkGroupName:
        //   arg.securityWorkGroupNames && arg.securityWorkGroupNames
      };
      delete params.securityWorkGroupNames;
      delete params.alarmTime;
      delete params.startTime;
      delete params.endTime;
      // }
      const loading = _this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(
        api.historyAlarm.sreachAlarm,
        Object.assign(
          {
            pageNum: page.currentPage,
            pageSize: page.pageSize,
          },
          params
        )
      ).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (response.success) {
          _this.tableData = Object.freeze(
            response.returnObj ? response.returnObj.list : []
          );
          _this.page.total = Object.freeze(
            response.returnObj ? response.returnObj.total : []
          );
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList(this.page, this.queryForm);
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList(this.page, this.queryForm);
    },
    //面板告警来源选择
    handleChange(data) {
      this.queryForm.deviceName = data[1] || "";
    },
    handleView(row) {
      this.uploadVideoShow = !(row.alarmType == 50101 || row.alarmType == 50102 || row.alarmType == 50103);
      const params = {
        alarmId: row.alarmId,
      };
      this.$fetch(api.alarm.getAlarmDetail, params).then((res) => {
        if (res && res.success) {
          this.currentAlarm = res.returnObj;
          this.currentAlarm.alarmType = res.returnObj.alarmType;
          this.currentAlarm.securityWorkGroupNames = row.securityWorkGroupNames;
          if (this.currentAlarm.similarity >= 1) {
            this.currentAlarm.similarity = 100;
          } else {
            this.currentAlarm.similarity = (this.currentAlarm.similarity * 100).toFixed(
              2
            );
          }
          this.currentAlarm.pictureList =
            this.currentAlarm.filePicSourceLists &&
            this.currentAlarm.filePicSourceLists.length &&
            this.currentAlarm.filePicSourceLists.filter((item) => {
              if (item.picResourceType !== 2) {
                return {
                  resourceCode: item.resourceCode,
                  picResourceType: item.picResourceType,
                };
              }
            });
          // 手动告警上传视频
          this.currentAlarm.manuaAlarmPicList = this.currentAlarm.filePicSourceLists.filter(
            (item) => {
              if (item.picResourceType == 2) {
                return {
                  resourceCode: item.resourceCode,
                  picResourceType: item.picResourceType,
                  resourceName: item.resourceName,
                };
              }
            }
          );
          // this.$refs.alarmDetail.open();
          this.showPanel = true;
        } else {
          this.$message.warning(res.msgContent);
        }
      });
    },
    closeDialog() {
      this.showPanel = false;
      // this.$refs.alarmDetail.close();
    },
    alarmColor(level) {
      level = parseInt(level);
      let className = "";
      if (level === 1) {
        className = "instancy";
      }
      if (level === 2) {
        className = "severity";
      }
      if (level === 3) {
        className = "general";
      }
      if (level === 4) {
        className = "common";
      }
      return className;
    },
    handelShowTaskDetail() {
      if (this.currentAlarm.taskCode) {
        this.$fetch(api.bas.getTaskDetail, {
          taskCode: this.currentAlarm.taskCode,
        }).then((response) => {
          if (response && response.success) {
            //成功才打开
            this.showPanelTask = true;
            // this.$refs.taskDetail.open();
            const params = {
              fileInfoList: response.returnObj.fileInfoList,
              subTaskInfoList: response.returnObj.subTaskInfoList,
              taskExecutionLogList: _.sortBy(response.returnObj.taskExecutionLogList, [
                "operateTime",
              ]),
            };
            this.currentTask = _.assign({}, params, response.returnObj.taskInfo);
            if (this.currentTask.status == 9) {
              // 任务已完成
              this.taskOption = taskOptionFinish(this);
              console.log(this.taskOption, "this.taskOption");
            } else if (this.currentTask.status != 9) {
              // 任务未完成
              this.taskOption = taskOption(this);
            }
          } else {
            this.$message.error(response.msgContent);
          }
        });
      } else {
        this.$message({
          showClose: false,
          message: this.$t("historyAlarm.message.unableView"),
          type: "warning",
          duration: 2000,
        });
      }
    },
    handleTabChange(column) {
      this.currentTab = column;
    },
    // 初始化日期格式
    initDateFormat() {
      const startDate = new Date(Date.now() - 89 * 24 * 3600 * 1000);
      const resetStartDate = Dates.format(startDate, "yyyy-MM-dd HH:mm:ss");
      const resetEndDate = Dates.format(new Date(), "yyyy-MM-dd HH:mm:ss");
      return [resetStartDate, resetEndDate];
    },
    getAreaTree() {
      this.$fetch(api.cms.getArea).then((response) => {
        if (response && response.success) {
          this.areaTree = response.returnObj;
          // this.filterOption = alarmFilterOption(this.areaTree)
        }
      });
    },
    // 获取联动设备
    getFastLinkDev() {
      this.deviceArr = [];
      this.videoDeviceArr = [];
      let currentDevice = {
        deviceName: this.currentAlarm.deviceName,
        thirdDeviceId: this.currentAlarm.thirdAlarmDevId,
      };
      this.deviceArr.push(currentDevice);
      this.videoDeviceArr.push(currentDevice);
      if (this.deviceArr.length == 1 || this.videoDeviceArr.length == 1) {
        this.playVideo();
      } else {
        this.showFastLinkDeviceList(this.videoDeviceArr);
      }
    },
    // 展示联动设备列表
    showFastLinkDeviceList(list) {
      this.fastLinkDevice = list;
      this.$refs.fastLinkDeviceList.open("back");
    },
    // 查看录像
    viewVideo() {
      if (!this.currentAlarm.deviceName) {
        this.$message.error(this.$t("historyAlarm.message.noDeviceInfor"));
        return;
      }
      if (!this.currentAlarm.startTime && !this.currentAlarm.endTime) {
        this.$message.error(this.$t("historyAlarm.message.noDevicePlan"));
        return;
      }
      this.getFastLinkDev();
    },
    playVideo(type, item) {
      const startTime = this.currentAlarm.startTime;
      const endTime = this.currentAlarm.endTime;
      this.$refs.videoPlayer.open({
        playType: "back",
        ocxVisible: true,
        cameraCode: item ? item.thirdDeviceId : this.currentAlarm.thirdAlarmDevId,
        cameraName: item ? item.deviceName : this.currentAlarm.deviceName,
        backStartTime: Dates.dayjs(startTime).format("YYYY/MM/DD HH:mm:ss"),
        backEndTime: Dates.dayjs(endTime).format("YYYY/MM/DD HH:mm:ss"),
        z: 2000,
        x: 580,
        y: 200,
      });
    },
    confirmDetail() {
      this.$refs.taskDetail.showSingleDialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.timeLine {
  :deep .el-timeline-item__timestamp {
    //color: #ffffff;
  }

  :deep .el-timeline-item__content {

    p {
      margin: 12px 0;
    }

    .action {
      position: absolute;
      top: -12px;
      left: 35%;
      background: #407aee;
      padding: 4px 8px;
      border-radius: 5px;
      color: #ffffff;
    }
  }

  :deep .el-timeline-item__node {
    box-shadow: 0px 0px 5px 4px #407aee;
  }
}

.device-name {
  position: relative;

  .el-button {
    position: absolute;
    right: 10px;
    // top: 10px;
  }
}

.file-item {
  margin-right: 5px;
  background-color: #ffffff;
  position: relative;

  .play-icon {
    position: absolute;
    top: 1px;
    left: 30px;
    font-size: 22px;

    &:hover {
      font-size: 25px;
    }
  }
}

.file-item,
.file-comp {
  height: 88px;
  width: 88px;
  line-height: 88px;

  &:nth-child(3) {
    margin-right: 0;
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
@import "../style/history.scss";

.history-alarm {
  display: flex;
  flex-direction: column;

  .app-panel {
    z-index: 2000 !important;
  }

  .tip {
    font-size: 15px;
    color: #e8eaee;
    margin-bottom: 5px;
    border-left: 5px solid #407aee;
    padding-left: 10px;
    margin-bottom: 20px;
  }

  .ioc-detail {

    // padding: 20px 50px;
    .ioc-group {
      // @include set_theme_color(background-color, blur-color);
      padding: 10px;

      .el-col {
        margin-bottom: 12px;
      }

      .ioc-group__title {
        font-size: 15px;
        // color: #e8eaee;
        margin-bottom: 5px;
        border-left: 5px solid #407aee;
        padding-left: 10px;
      }
    }
  }

  .alarm-name {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 155px;
    white-space: nowrap;
    vertical-align: middle;
  }

  .footer-content {
    margin-top: 10px;
    text-align: right;
  }

  .ioc-history__list {
    flex: 1;
  }

  .img-content {
    .ioc-detail__content {
      width: 80%;
    }

    // padding-left: 20px;
  }

  .open-devices-button {
    color: #0086ff;
    font-weight: bolder;
    cursor: pointer;
    position: relative;
    top: -28px;
    left: 73%;
  }

  .tag-container {
    height: 28px;
    position: relative;

    input {
      padding-right: 60px;
      padding-left: 8px;
    }
  }

  .choice-btn {
    position: absolute;
    // color: #0086ff;
    top: 0;
    right: 5px;
    z-index: 3;
  }

  .claer-area-btn {
    position: absolute;
    top: 8px;
    color: #ccc;
    right: 40px;
    z-index: 3;
    cursor: pointer;
  }

  .handle-desc {
    display: inline-block;
    word-break: break-all;
  }

  .export-tips {
    margin-left: 5px;
    color: red;
    vertical-align: middle;
  }

  .taskDetail-container {

    // margin-left: 20%;
    .el-dialog {
      // margin-top: 20vh !important;
    }

    z-index: 2015 !important;

    .ioc-detail__box {
      margin-top: 10px;
    }
  }
}

.v-modal {
  z-index: 1998 !important;
}
</style>
